<script>
  import { pathImages, tabcouleur } from "../components/conf.js";
  import { link } from "svelte-spa-router";

  export let elements;
  let showPopup;
  let idPersonne; //Id a envoyer au modal

  const onOpenClick = (id) => {
    idPersonne = id;
    showPopup = true;
  };

  const onPopupClose = () => {
    showPopup = false;
  };
</script>

<div class="container-fluid">
  {#each elements as element}
    <div class="row ">
      <div class="col-xs-2 float-sm-left">
        <img
          src="{pathImages}team/avatar_{element.EM_PARTI_LE == '1970-01-01'
            ? element.EM_ID
            : '00'}.jpg"
          style="width:90px;"
          alt="User"
        />
        <div>
          <a href="/personne/{element.EM_ID}" use:link
            ><i class="icon ion-md-person ml-3" />P</a
          >
          <a href="/"><i class="icon ion-md-create ml-3" />C</a>
          <a href="/"><i class="icon ion-md-pulse ml-3" />G</a>
        </div>
      </div>

      <div class="carte_corps col-xs-9 float-sm-left">
        <strong
          >{element.EM_NOM}{#if element.EM_CADRE == 1}
            <span class="text-danger"> (Cadre)</span>
          {/if}</strong
        >
        <p
          style="background-color:#{element.EM_PARTI_LE == '1970-01-01'
            ? tabcouleur[element.EM_POSTE]
            : '04A2FC'}"
        >
          {element.EM_POSTE.substr(0, 25)}<span class="text-warning"
            >{element.EM_ALTERNANT == 1 ? " - (Alternant)" : ""}</span
          >
        </p>
        <p class="little_P">
          <span>entré(e) le : {element.EM_ENTRE_LE}</span> -
        </p>
        {#if element.EM_PARTI_LE != "1970-01-01"}
          <br />
          <p class="little_P danger">
            Parti le : {element.EM_PARTI_LE}
          </p>
        {:else}
          <p class="little_P">
            <span>age : {element.AGE}</span> -
            <span>anc. : {element.OLD}</span>
          </p>
          <br />
        {/if}
      </div>
    </div>
  {/each}
</div>

<style>
  .little_P {
    font-size: 0.75em;
    color: rgb(91, 90, 90);
    margin-top: -15px;
  }
  .carte_corps {
    padding-left: 5px;
    margin-bottom: 15px;
  }
</style>
